import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteMatchListPayload } from '@app-store/slices/matchLists/delete'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IDeleteMatchListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchLists.delete

function* deleteMatchListSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete('/companies/match-lists/delete', { data: payload.data })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
            notification.success({
                message: 'Match lists deleted successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteMatchListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteMatchListSagaTask)
}

export default deleteMatchListSaga
